const LAMPORTS_PER_SOL = BigInt(1_000_000_000)
const ZERO_LAMPORTS = BigInt(0)

export function formatSolListingPriceFromNumber(value: number): string {
  if (!Number.isFinite(value) || value <= 0) {
    throw new Error("Price must be greater than 0")
  }

  return value.toFixed(9).replace(/\.?0+$/, "")
}

export function parseSolanaListingPriceSolToLamports(value: string): string {
  const trimmed = value.trim()
  if (!trimmed) {
    throw new Error("Price is required")
  }

  if (!/^\d+(\.\d+)?$/.test(trimmed)) {
    throw new Error(
      'Price must be a SOL amount. Example: "1" for 1 SOL or "0.5" for 0.5 SOL.',
    )
  }

  const [wholeSol, fractionalSol = ""] = trimmed.split(".")
  if (fractionalSol.length > 9) {
    throw new Error("Price supports up to 9 decimal places")
  }

  const paddedFractional = fractionalSol.padEnd(9, "0")
  const lamports =
    BigInt(wholeSol) * LAMPORTS_PER_SOL + BigInt(paddedFractional || "0")

  if (lamports <= ZERO_LAMPORTS) {
    throw new Error("Price must be greater than 0")
  }

  return lamports.toString()
}

export function formatSolanaListingPriceLamportsAsSol(value: string): string {
  const lamports = BigInt(value)
  const wholeSol = lamports / LAMPORTS_PER_SOL
  const fractionalLamports = lamports % LAMPORTS_PER_SOL

  if (fractionalLamports === ZERO_LAMPORTS) {
    return wholeSol.toString()
  }

  const fractional = fractionalLamports
    .toString()
    .padStart(9, "0")
    .replace(/0+$/, "")
  return `${wholeSol}.${fractional}`
}
